import { faPrint } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { TestConfigurationPrintoutApi } from "src/api/generated/erp/configurator/api/configuratorTesting/testConfigurationPrintoutApi.ts";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import { downloadFile } from "src/utils/fileDownloading.ts";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues.ts";

export interface TestConfigurationPrintoutButtonProps {
	configuratorType: PartConfiguratorType;
	/** The values of the configuration being tested, resolved as its form resolves them. */
	resolvePropertyValues: () => Promise<ConfigurationPropertyValues>;
}

export const TestConfigurationPrintoutButton = ({
	configuratorType,
	resolvePropertyValues,
}: TestConfigurationPrintoutButtonProps) => {
	return (
		<AsyncButton
			label={i18n.t("printout")}
			icon={faPrint}
			color={"secondary"}
			onClick={async () => {
				const fileHandle = await TestConfigurationPrintoutApi.getTestConfigurationPrintout({
					configuratorType,
					propertyValues: await resolvePropertyValues(),
				});
				downloadFile(fileHandle);
			}}
		/>
	);
};
